import { Swiper, utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { serializeForm, addToCart, reRenderShopifySections } = utils

class HHProductForm extends LitElement {
  constructor() {
    super()
    this.section = this.closest('.js-product-section')
    this.form = this.querySelector('form:not(.tvg-product-form)')
    this.quanityInput = this.querySelector('[name="quantity"]')
    this.submitButton = this.querySelector('[type="submit"]:not(.tvg-product-form-button)')
    console.log(this.submitButton)
    this.productSkin = this.querySelector('.js-product-skin')
    this.productData = JSON.parse(this.querySelector('.js-product-json').textContent)
    if (this.submitButton !== null) {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    }

    this.querySelectorAll('.js-product-variants').forEach((select) => {
      select.addEventListener('change', (e) => {
        const triggerSwatch = !e.detail?.id
        this.onChangeVariant(e, triggerSwatch)
      })
    })

    this.productSkin?.addEventListener('click', (e) => {
      if (document.querySelector('.try-it-on') === null) return

      window.scroll({
        top:
          document.querySelector('.try-it-on').offsetTop -
          document.querySelector('.header-wrapper').clientHeight,
        behavior: 'smooth',
      })
    })

    this.dropdownProductFormSelector = this.querySelector('.product-form__variant-item.product-form__variant-item--current')
    this.dropdownProductFormSelectorMobile = this.querySelector('.product-form__variant-item.product-form__variant-item--mobile-only')
    this.dropdownProductFormCurrent = this.querySelectorAll('.product-form__variant-item[data-current-variant-id]')
    this.dropdownProductFormList = this.querySelector('.product-form__variant-list')
    this.dropdownProductFormListItems = this.querySelectorAll('.js-product-form-item')

    if (this.dropdownProductFormSelector && this.dropdownProductFormList) {
      this.dropdownProductFormSelector.addEventListener('click', () => {
        this.dropdownProductFormSelector.classList.toggle('expanded')
        this.dropdownProductFormList.classList.toggle('expanded')
      })
    }

    if (this.dropdownProductFormSelectorMobile && this.dropdownProductFormList) {
      this.dropdownProductFormSelectorMobile.addEventListener('click', () => {
        this.dropdownProductFormSelector.classList.remove('expanded')
        this.dropdownProductFormList.classList.remove('expanded')
      })
    }

    document.addEventListener('click', (event) => {
      const isInsideSelector = this.dropdownProductFormSelector?.contains(event.target)
      const isInsideList = this.dropdownProductFormList?.contains(event.target)
    
      if (!isInsideSelector && !isInsideList) {
        this.dropdownProductFormSelector?.classList?.remove('expanded')
        this.dropdownProductFormList?.classList?.remove('expanded')
      }
    })
    
    if (this.dropdownProductFormListItems.length > 0) {
      this.dropdownProductFormListItems.forEach((listItem) => {
        listItem.addEventListener('click', () => {
          const listItemVariantId = listItem.dataset.variantId
          const variantSwatches = document.querySelectorAll('hh-variant-swatches .js-swatch-item')
          if (variantSwatches.length > 0) {
            for (const swatch of variantSwatches) {
              const swatchId = swatch.dataset.id
              if (listItemVariantId === swatchId) {
                swatch.click()

                const swatchSwiper = swatch.closest('.js-slider.swiper-initialized')
                if (!swatchSwiper) break

                const swiperInstance = swatchSwiper.swiper;
                if (!swiperInstance) break

                let indexOfActiveElement = -1
                const swiperSwatches = swatchSwiper.querySelectorAll(".js-swatch-item:not(.hidden)")

                for (let i = 0; i < swiperSwatches.length; i++) {
                  if (swiperSwatches[i].classList.contains("active")) {
                    indexOfActiveElement = i
                    break
                  }
                }

                if (indexOfActiveElement !== -1) {
                  swiperInstance.slideTo(indexOfActiveElement)
                }

                break
              }
            }
          }
        })
      })
    }

    let ticking = false
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const rect = this.getBoundingClientRect();
          if (rect.top < 0) {
            const height = 152; // Had to hardcode this as it's incrementing its own height
            this.style.setProperty('--form-float-height', `${height}px`);
            if (window.innerWidth < 750) {
              setTimeout(() => {
                this.classList.add('floating')
              }, 100)
            }
          } else {
            this.classList.remove('floating')
          }
          ticking = false;
        })
        ticking = true;
      }
    })

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 750) {
        this.classList.remove('floating')
      }
    })
  }

  connectedCallback() {
    super.connectedCallback()

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.receiver.disconnect()
  }

  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    this.submitButton.setAttribute('disabled', true)
    this.submitButton.classList.add('loading')

    const product = JSON.parse(serializeForm(this.form))

    window.dispatchEvent(new CustomEvent('tvg-cart-add', {
      detail: {
        product: product
      },
      bubbles: true,
      composed: true
    }));


    this.submitButton.removeAttribute('disabled')
    this.submitButton.classList.remove('loading')
  }

  onChangeVariant(e, triggerSwatch = true) {
    const value = e.detail?.id || e.target.value

    if (!value) return
    const input = this.querySelector('input[name="id"]')
    input.value = value
    input.dispatchEvent(new Event('change', { bubbles: true }))

    const activeVariant = this.productData.variants.find(variant => +variant.id === +value)

    if (activeVariant.available) {
      this.querySelector('[type="submit"]')?.removeAttribute('disabled')
    } else {
      this.querySelector('[type="submit"]')?.setAttribute('disabled', true)
    }

    window.history.replaceState({}, '', `${this.dataset.url}?variant=${value}`)

    if (!triggerSwatch) return

    this.section
      ?.querySelectorAll('.js-variant-swatches')
      .forEach((swatches) => {
        swatches.dispatchEvent(
          new CustomEvent('SWATCH_CHANGE', {
            bubbles: true,
            detail: {
              id: value,
            },
          })
        )
      })

    const productFormItems = this.section?.querySelectorAll('.js-product-form-item')
    if (productFormItems.length > 0) {
      productFormItems.forEach((formItem) => {
        const formItemId = formItem.dataset.variantId
        if (formItemId === value) {
          formItem.classList.add('product-form__variant-item--list-item-selected')

          const currentProductFormItems = this.section?.querySelectorAll(`[data-current-variant-id]`)
          if (currentProductFormItems.length > 0) {
            currentProductFormItems.forEach((currentFormItem) => {
              currentFormItem.dataset.currentVariant = value
              const currentFormItemTitle = currentFormItem.querySelector('[data-current-title]')
              currentFormItemTitle.innerHTML = formItem.dataset.variantTitle
            })
          }
        } else {
          formItem.classList.remove('product-form__variant-item--list-item-selected')
        }
      })
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-form', HHProductForm)